export const UPDATE = 'update_field';
export const UPDATE_ADDRESS = 'update_address';
export const UPDATE_CONTACT = 'update_contact';
export const UPDATE_PARTNER = 'update_partner';
export const UPDATE_QUESTION = 'update_question';
export const ERRORS = 'errors';

export interface FormState {
  partner: { code: string, repEmail: string, name?: string, franchiseCode: string };
  id: string;
  name: string;
  description: string;
  phone: string;
  url: string;
  facebookPage: string;
  instagramProfile: string;
  info: string;
  token: string;
  address: {
    streetNumber: string;
    streetName: string;
    unit: string;
    city: string;
    stateCode: string;
    postalCode: string;
    country: string;
  };
  plan: string;
  contact: {
    firstName: string;
    lastName?: string;
    email: string;
    phone: string;
    onboardingPreference: string;
  };
  questions: {
    [key: string]: {
      label: string,
      placeholder: string,
      response?: string,
      type?: string,
      required?: boolean,
      options?: Array<{
        label: string;
        value: string;
      }>
    }
  };
}

export interface State {
  errors: any;
  form: FormState;
}

export const initialState = {
  errors: {},
  form: {
    partner: {
      code: '',
      repEmail: '',
      franchiseCode: '',
    },
    id: '',
    name: '',
    description: '',
    phone: '',
    url: '',
    facebookPage: '',
    instagramProfile: '',
    info: '',
    token: '',
    address: {
      streetNumber: '',
      streetName: '',
      unit: '',
      city: '',
      stateCode: '',
      postalCode: '',
      country: '',
    },
    pricePlan: '',
    contact: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      onboardingPreference: 'email',
    },
    questions: {},
    plan: '',
  },

};

export type ActionType =
  typeof UPDATE |
  typeof UPDATE_ADDRESS |
  typeof UPDATE_CONTACT |
  typeof UPDATE_PARTNER |
  typeof UPDATE_QUESTION |
  typeof ERRORS;

type Action = {
  type: ActionType,
  payload: { [key: string]: any }
};

const capitalize = (string: string) => `${string.charAt(0).toUpperCase()}${string.substr(1, string.length)}`;

export const reducer = (state: State = initialState, action: Action): State => {
  const { name, value } = action.payload;
  switch (action.type) {
    case UPDATE: {
      return {
        ...state,
        errors: {
          ...state.errors,
          [name]: false,
        },
        form: {
          ...state.form,
          [name]: value,
        },
      };
    }
    case UPDATE_ADDRESS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          [name]: false,
        },
        form: {
          ...state.form,
          address: {
            ...state.form.address,
            // Reset stateCode when we change country because 🙃
            stateCode: (name === 'country') ? '' : state.form.address.stateCode,
            [name]: value,
          },
        },
      };
    }
    case UPDATE_CONTACT: {
      const errorField = `contact${capitalize(name)}`;
      return {
        ...state,
        errors: {
          ...state.errors,
          [errorField]: false,
        },
        form: {
          ...state.form,
          contact: {
            ...state.form.contact,
            [name]: value,
          },
        },

      };
    }
    case UPDATE_PARTNER: {
      const errorField = `partner${capitalize(name)}`;
      return {
        ...state,
        errors: {
          ...state.errors,
          [errorField]: false,
        },
        form: {
          ...state.form,
          partner: {
            ...state.form.partner,
            [name]: value,
          },
        },
      };
    }
    case UPDATE_QUESTION: {
      const errorField = `question${capitalize(name)}`;
      return {
        ...state,
        errors: {
          ...state.errors,
          [errorField]: false,
        },
        form: {
          ...state.form,
          questions: {
            ...state.form.questions,
            [name]: {
              ...state.form.questions[name],
              response: value,
            },
          },
        },
      };
    }
    case ERRORS: {
      return {
        ...state,
        errors: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
